import axios from 'axios'
import  msal  from '@api/msal'

const axiosInstance = axios.create({
  baseURL: process.env.SYSTEM_URL ,
  headers: {
    'Content-Type': ' application/json',
    'Cache-Control': 'no-cache'
  }
})

axiosInstance.interceptors.request.use(config => {
  // We can add logic to attach the token in here
 //  console.log('[config] : ', config);
 let idToken = localStorage.getItem('msal.idtoken')
 let accessToken = sessionStorage.getItem('access-token')
 config.headers['Authorization'] = idToken ? `BEARER ${idToken}` : ''
 config.headers['access-token'] = accessToken ? accessToken : ''
  return config
}, (error) => {
  console.log('Intercepter Error:', error)
  throw error
})

axiosInstance.interceptors.response.use(config => {
  let data = config.data
  if(data) {
    if(data.responseStatus) {
      let message = data.responseStatus.responseCode
      if(message == 'ERR009') {
        msal.getTokenLogOn()
        return
      }
    }
  }
  return config
}, (error) => {
  console.error('error , ' , error)
  if(error.response) {
      if (error.response.status === 401) {
        msal.getTokenLogOn()
        return
      }
    }
  throw error
})

export default axiosInstance
